/* eslint-disable */
/* stylelint-disable */
import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
};

export type Audio = {
  __typename?: 'Audio';
  /** Source: audio_file table */
  audioFiles: Array<AudioFile>;
  audioId: Scalars['Int'];
  /** Source: audio_metadata table */
  audioMetadata?: Maybe<AudioMetadata>;
  /** Audio preview redirect URL for highest quality audio file */
  audioPreviewUrl?: Maybe<Scalars['String']>;
  /** Source: audio_transformation_request table */
  audioTransformation?: Maybe<AudioTransformation>;
  /** User that originally uploaded the audio */
  audioUploader?: Maybe<MediaUploader>;
  caption?: Maybe<Scalars['String']>;
  /** Color code corresponding to audio type and origin */
  color?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  createdUnixTimestamp?: Maybe<Scalars['Float']>;
  derivedFromAudioId?: Maybe<Scalars['Float']>;
  /** Audio file download policy for mobile clients based on audio duration */
  downloadRule?: Maybe<AudioDownloadRule>;
  duration?: Maybe<Scalars['Float']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isJointRecording?: Maybe<Scalars['Boolean']>;
  isNotAllowedEchoes?: Maybe<Scalars['Boolean']>;
  isNotAllowedVideos?: Maybe<Scalars['Boolean']>;
  /** Podcast language setting */
  language?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  origin?: Maybe<Scalars['String']>;
  originalAudioId?: Maybe<Scalars['Float']>;
  /** Non human-readable original audio web ID generated from original audio ID */
  originalAudioWebId?: Maybe<Scalars['String']>;
  originalUserId?: Maybe<Scalars['Float']>;
  /** Show the audio belongs to */
  show?: Maybe<Show>;
  type?: Maybe<AudioType>;
  /** Non human-readable web audio ID generated from audio ID */
  webAudioId: Scalars['String'];
};

/** Audio file download policy for mobile clients */
export enum AudioDownloadRule {
  /** Always download audio files with duration less than a minute */
  AlwaysDownload = 'alwaysDownload',
  /** Do not download audio files with duration of an hour or greater */
  NeverDownload = 'neverDownload',
  /** Prioritize downloading audios with duration between 1 minute and 1 hour when connected to Wi-Fi */
  PrioritizeDownloadingOnWifi = 'prioritizeDownloadingOnWifi'
}

export type AudioFile = {
  __typename?: 'AudioFile';
  audioFileId: Scalars['Float'];
  bitrate?: Maybe<Scalars['Float']>;
  channels: Scalars['Float'];
  created: Scalars['DateTime'];
  duration?: Maybe<Scalars['Float']>;
  extension: Scalars['String'];
  fileSize: Scalars['Float'];
  isDeleted: Scalars['Boolean'];
  isOriginal: Scalars['Boolean'];
  modified?: Maybe<Scalars['DateTime']>;
  sampleRate: Scalars['Float'];
  url: Scalars['String'];
};

/**
 * Paginated list of audios belonging to a given show
 *        - Includes audios that are currently processing
 */
export type AudioLibrary = {
  __typename?: 'AudioLibrary';
  /** Audios associated with a given Anchor show */
  audios: Array<Audio>;
  /** Information used for pagination */
  pageInfo: PageInfo;
};

export type AudioMetadata = {
  __typename?: 'AudioMetadata';
  appleMusicTrackId?: Maybe<Scalars['String']>;
  appleMusicUrl?: Maybe<Scalars['String']>;
  attributionDescription?: Maybe<Scalars['String']>;
  attributionUrl?: Maybe<Scalars['String']>;
  audioId: Scalars['Float'];
  backgroundLeadInDuration?: Maybe<Scalars['String']>;
  conferenceCallFileUrl?: Maybe<Scalars['String']>;
  conferenceCallHostId?: Maybe<Scalars['String']>;
  conferenceCallId?: Maybe<Scalars['String']>;
  conferenceCallParticipantUserIds?: Maybe<Scalars['String']>;
  conferenceCallSessionId?: Maybe<Scalars['String']>;
  editingAttributionDescription?: Maybe<Scalars['String']>;
  editingAttributionUrl?: Maybe<Scalars['String']>;
  greenroomRoomId?: Maybe<Scalars['String']>;
  isMarkedAsExternalAd?: Maybe<Scalars['Boolean']>;
  isPodcastTrailerAudio?: Maybe<Scalars['Boolean']>;
  preProcessedConferenceCallId?: Maybe<Scalars['String']>;
  previewAudioUrl?: Maybe<Scalars['String']>;
  previewDuration?: Maybe<Scalars['String']>;
  speechSynthesisTaskId?: Maybe<Scalars['String']>;
  spotifyTrackId?: Maybe<Scalars['String']>;
  spotifyUrl?: Maybe<Scalars['String']>;
  thirdPartyAlbumTitle?: Maybe<Scalars['String']>;
  thirdPartyArtistName?: Maybe<Scalars['String']>;
  thirdPartyDuration?: Maybe<Scalars['String']>;
  thirdPartyImageUrl?: Maybe<Scalars['String']>;
  thirdPartyTrackName?: Maybe<Scalars['String']>;
};

export type AudioTransformation = {
  __typename?: 'AudioTransformation';
  /** Arguments included in the original audio transformation request */
  arguments?: Maybe<Scalars['String']>;
  /** Current state of the audio transformation request */
  state?: Maybe<AudioTransformationRequestState>;
  /** Type of the audio transformation request */
  type?: Maybe<AudioTransformationType>;
};

/** Current state of the audio transformation request */
export enum AudioTransformationRequestState {
  Failed = 'failed',
  Finished = 'finished',
  Started = 'started',
  Waiting = 'waiting'
}

/** Type of the audio transformation request */
export enum AudioTransformationType {
  /** Default operation for user uploaded audio */
  AnchorFormat = 'anchorFormat',
  /** Add/change background music */
  Background = 'background',
  /** Combine multiple audio files into one */
  Merge = 'merge',
  /** Alter length of audio file */
  Trim = 'trim'
}

/** Type of audio file */
export enum AudioType {
  Ad = 'ad',
  Background = 'background',
  Callin = 'callin',
  Default = 'default',
  Interlude = 'interlude',
  Music = 'music',
  Shoutout = 'shoutout',
  Soundfx = 'soundfx'
}

/** Information associated with a specific upload request */
export type AudioUploadRequest = {
  __typename?: 'AudioUploadRequest';
  /** If the request has been fully processed, the audio corresponding to the upload request */
  audio?: Maybe<Audio>;
  created: Scalars['DateTime'];
  /** If the upload request failed, the reason is described here */
  failureReason?: Maybe<Scalars['String']>;
  /** Filename the upload is to be stored under */
  filename: Scalars['String'];
  /** Basic information on the user who made the upload request */
  mediaUploader: MediaUploader;
  modified?: Maybe<Scalars['DateTime']>;
  /** Unique UUID corresponding to a specific upload request */
  requestUuid: Scalars['String'];
  /** State of the upload request */
  state: UploadRequestState;
  /** Which storage provider the content is stored with, depends on if the content is related to an enterprise podcast */
  storageProviderType: StorageProviderType;
  /** Upload request type, could be audio or video; default=audio */
  uploadType: UploadType;
};

/** Details of the parts that were uploaded using multi-part upload */
export type CompletedUploadPart = {
  /** Entity tag returned when the part was uploaded */
  etag: Scalars['String'];
  /** Index of the part that was uploaded */
  partNumber: Scalars['Float'];
};

/** Data submitted on upload request creation */
export type CreateUploadRequestInput = {
  /** Name of the file being uploaded */
  filename: Scalars['String'];
  /**
   * Indicates if upload contains multiple parts
   *      MUST include numParts for multipart upload
   *      default=false
   */
  isMultipartUpload?: InputMaybe<Scalars['Boolean']>;
  /** For multipart upload, number of parts in upload */
  numParts?: InputMaybe<Scalars['Float']>;
  /** Upload may either be audio or video type, default=audio */
  uploadType?: InputMaybe<UploadType>;
  /** userId of the user making the upload request */
  userId: Scalars['Float'];
};

/** Union type for possible responses to upload creation request */
export type CreateUploadRequestResponse = MultipartUploadRequestSubmitted | UploadRequestRejected | UploadRequestSubmitted;

export type Episode = {
  __typename?: 'Episode';
  /** The total number of ads in the episode. */
  adCount: Scalars['Float'];
  /** When the episode was first created within Anchor */
  created: Scalars['DateTime'];
  /** Episode description. May contain HTML for formatting purposes. */
  description?: Maybe<Scalars['String']>;
  episodeId: Scalars['Int'];
  hourOffset: Scalars['Int'];
  /** Whether the episode is deleted or not. Generally, episodes where isDeleted=true will not even appear in query results. */
  isDeleted: Scalars['Boolean'];
  /** When the episode was last modified within Anchor */
  modified?: Maybe<Scalars['DateTime']>;
  /** If null, it means the episode is still a Draft and is not yet published. If not null, it will be the episode publish date. Note this is not necessarily when it was published by a user (which could have been earlier or later in time), but rather the publish date displayed in the external feeds. */
  publishOn?: Maybe<Scalars['DateTime']>;
  /** Show the episode belongs to */
  show: Show;
  /** Streaming ad cue points for the episode, if applicable. Otherwise, array will be empty. */
  streamingAdCuePoints: Array<EpisodeStreamingAdCuePoint>;
  /** Episode title */
  title?: Maybe<Scalars['String']>;
  /** Non human-readable web episode ID generated from episode ID */
  webEpisodeId: Scalars['String'];
};

/** Union type for possible responses to fetch episode */
export type EpisodeResponse = Episode | ForbiddenError;

export type EpisodeStreamingAdCuePoint = {
  __typename?: 'EpisodeStreamingAdCuePoint';
  /** how many ads may be played during this ad slot */
  adCount: Scalars['Int'];
  /** when this cue point was first created within Anchor */
  created: Scalars['DateTime'];
  /** when this cue point was first created within Anchor (represented as Unix epoch seconds) */
  createdUnixTimestamp: Scalars['Int'];
  /** Which type of ads can be placed in this slot (preRoll, midRoll, or postRoll) */
  placementType: Scalars['String'];
  /** the start time, measured from beginning of the episode, to start playing ads (represented in milliseconds) */
  startTime: Scalars['Int'];
};

/** Error indicating unauthorized request attempt */
export type ForbiddenError = GenericError & {
  __typename?: 'ForbiddenError';
  message: Scalars['String'];
};

export type GenericError = {
  message: Scalars['String'];
};

/** Basic information on the user who uploaded a given media file */
export type MediaUploader = {
  __typename?: 'MediaUploader';
  bio?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  userId: Scalars['Int'];
};

/** Successful multipart upload request creation */
export type MultipartUploadRequestSubmitted = {
  __typename?: 'MultipartUploadRequestSubmitted';
  /** Path the file is to be uploaded to; Includes file folder and filename */
  fileKey: Scalars['String'];
  /** Filename (with extension) the file is to be saved under */
  filename: Scalars['String'];
  /** Unique UUID associated with the upload request */
  requestUuid: Scalars['String'];
  /** List of url parts associated with the multipart upload */
  signedUrlParts: Array<SignedUrlParts>;
  /** Storage provider specific ID for multi-part uploads;     AWS: Generated on multipart upload creation,     GCP: Corresponds to file folder guid */
  uploadId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create upload request */
  createUploadRequest: CreateUploadRequestResponse;
  /** Invoke upload processing after file upload is complete */
  processUpload: ProcessUploadResponse;
};


export type MutationCreateUploadRequestArgs = {
  input: CreateUploadRequestInput;
};


export type MutationProcessUploadArgs = {
  input: ProcessUploadInput;
};

/** Type used for resources that offer pagination */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Indicates if there is more to load after the current page */
  hasNextPage: Scalars['Boolean'];
  /** Token corresponding to the last element returned to be included in next pagination request */
  pageToken?: Maybe<Scalars['String']>;
};

/** Label indicating a permission that a user has access to */
export enum PermissionLabel {
  ActorRoleRead = 'actorRole_read',
  ActorRoleWrite = 'actorRole_write',
  AnalyticsView = 'analytics_view',
  EpisodeBuilder = 'episode_builder',
  EpisodeCreate = 'episode_create',
  EpisodeDelete = 'episode_delete',
  EpisodeInteractivity = 'episode_interactivity',
  EpisodePublish = 'episode_publish',
  EpisodeQuickUpload = 'episode_quickUpload',
  EpisodeUnpublish = 'episode_unpublish',
  EpisodeView = 'episode_view',
  PodcastDelete = 'podcast_delete',
  PodcastDistribution = 'podcast_distribution',
  PodcastManageUsers = 'podcast_manageUsers',
  PodcastSettings = 'podcast_settings',
  RevenueView = 'revenue_view',
  TargetRoleRead = 'targetRole_read',
  TargetRoleWrite = 'targetRole_write',
  Unknown = 'unknown',
  UserAdmin = 'user_admin',
  UserIssueToken = 'user_issueToken',
  UserRevokeToken = 'user_revokeToken',
  WalletManage = 'wallet_manage'
}

/** Arguments for invoking upload processing lambda after upload completion */
export type ProcessUploadInput = {
  /** Audio caption */
  caption?: InputMaybe<Scalars['String']>;
  /** Part details received on multi-part upload completion */
  completedUploadParts?: InputMaybe<Array<CompletedUploadPart>>;
  /** Episode the upload is associated with */
  episodeId: Scalars['Float'];
  /** Indicates if the audio was extracted from a video, default=false */
  isExtractedFromVideo?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if the upload request was single or multi-part */
  isMultipartUpload?: InputMaybe<Scalars['Boolean']>;
  /** Audio upload origin */
  origin?: InputMaybe<Scalars['String']>;
  /** Unique ID associated with the upload request */
  requestUuid: Scalars['String'];
  /** Station the upload is associated with */
  stationId: Scalars['Float'];
  /** Storage provider specific ID for the multi-part upload */
  uploadId?: InputMaybe<Scalars['String']>;
  /** Upload may either be audio or video type, default=audio */
  uploadType?: InputMaybe<UploadType>;
};

/** Unsuccessful process upload attempt */
export type ProcessUploadRejected = GenericError & {
  __typename?: 'ProcessUploadRejected';
  message: Scalars['String'];
};

/** Union type for possible responses to process upload request */
export type ProcessUploadResponse = ProcessUploadRejected | ProcessUploadSuccess;

/** Successful process upload response */
export type ProcessUploadSuccess = {
  __typename?: 'ProcessUploadSuccess';
  /** Unique ID associated with the upload request */
  requestUuid: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** Fetches a paginated list of audios associated with the showId */
  audioLibrary: AudioLibrary;
  /** Fetch upload request status by requestUuid */
  audioUploadRequest: AudioUploadRequest;
  /** Fetches an episode by episodeId. Returns error if episode does not exist. */
  getEpisode: EpisodeResponse;
  /** Fetches a show by showId. Returns error if show does not exist. */
  getShow: ShowResponse;
  /** Fetches information about the currently authenticated user */
  viewer: Viewer;
};


export type QueryAudioLibraryArgs = {
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  showId: Scalars['Int'];
};


export type QueryAudioUploadRequestArgs = {
  requestUuid: Scalars['String'];
};


export type QueryGetEpisodeArgs = {
  episodeId: Scalars['Int'];
};


export type QueryGetShowArgs = {
  showId: Scalars['Int'];
};

/** Details on an Anchor show, also known as the station */
export type Show = {
  __typename?: 'Show';
  /** Indicates if the show was deactivated or not */
  active: Scalars['Boolean'];
  color1?: Maybe<Scalars['String']>;
  color2?: Maybe<Scalars['String']>;
  color3?: Maybe<Scalars['String']>;
  /** When the show was first created */
  created: Scalars['DateTime'];
  /** Whether or not the user has been approved for beta Paywalls usage. Intentionally vague name to avoid exposure in network requests. */
  isPWEnabled: Scalars['Boolean'];
  /** When the basic show metadata was last modified. Note this does NOT track stationMetadata or other changes. */
  modified?: Maybe<Scalars['DateTime']>;
  /** primary show identifier. Equivalent to stationId, but this is the new name for that. */
  showId: Scalars['Int'];
  /** legacy name for the primary key identifier for a show */
  stationId: Scalars['Int'];
  /** Show title */
  title?: Maybe<Scalars['String']>;
  /** web version of stationId. Historically used to hide the numeric IDs from web clients, and therefore relied on by most Web components and logic. */
  webStationId: Scalars['String'];
  /** The status of the user's progress for completing wordpress related actions */
  wordpressStatus?: Maybe<WordpressStatus>;
};

/** Represents all permissions that a user has for a given showId */
export type ShowPermissions = {
  __typename?: 'ShowPermissions';
  permissions: Array<PermissionLabel>;
  /** primary show identifier. Equivalent to stationId, but this is the new name for that. */
  showId: Scalars['Int'];
  /** web version of stationId. Historically used to hide the numeric IDs from web clients, and therefore relied on by most Web components and logic. */
  webStationId: Scalars['String'];
};

/** Union type for possible responses to fetch episode */
export type ShowResponse = ForbiddenError | Show;

/** Urls associated with a multipart upload */
export type SignedUrlParts = {
  __typename?: 'SignedUrlParts';
  /** Signed URL part number for multi-part uploads */
  partNumber: Scalars['Float'];
  /** Signed URL for the given part */
  url: Scalars['String'];
};

/** Storage provider options; one of AWS or GCP */
export enum StorageProviderType {
  /** Amazon Web Services, used for storing most audio and video content */
  Aws = 'AWS',
  /** Google Cloud Platform, used for storing enterprise user content */
  Gcp = 'GCP'
}

/** Unsuccessful upload request creation */
export type UploadRequestRejected = GenericError & {
  __typename?: 'UploadRequestRejected';
  message: Scalars['String'];
};

/** State of the upload request */
export enum UploadRequestState {
  /** Upload request was manually cancelled */
  Cancelled = 'cancelled',
  /** Upload request failed */
  Failed = 'failed',
  /** Request successfully finished processing */
  Processed = 'processed',
  /** Initial state after upload request creation, before media has been uploaded */
  Requested = 'requested',
  /** Media was uploaded using the signed url, pre lambda processing */
  Uploaded = 'uploaded'
}

/** Successful upload request creation */
export type UploadRequestSubmitted = {
  __typename?: 'UploadRequestSubmitted';
  /** Path the file is to be uploaded to; Includes file folder and filename */
  fileKey: Scalars['String'];
  /** Filename (with extension) the file is to be saved under */
  filename: Scalars['String'];
  /** Unique UUID associated with the upload request */
  requestUuid: Scalars['String'];
  /** Signed url that provides temporary access to upload to the given storage provider */
  signedUrl: Scalars['String'];
};

/** Type of upload request: audio or video */
export enum UploadType {
  Audio = 'audio',
  Video = 'video'
}

/** Type exposing permissions that the current user is authorized for */
export type Viewer = {
  __typename?: 'Viewer';
  /** List of all Shows that the current user has at least some permission for */
  authorizedShows: Array<Show>;
  /** Allows looking up permissions the current user has for a specific show, via showId arg */
  permissionsForShow: Array<PermissionLabel>;
  /** Represents all permissions that the current user has for each showId */
  showPermissions: Array<ShowPermissions>;
};


/** Type exposing permissions that the current user is authorized for */
export type ViewerPermissionsForShowArgs = {
  showId: Scalars['Int'];
};

export enum WordpressStatus {
  CompletedImport = 'completedImport',
  ConnectedAccount = 'connectedAccount',
  CreatedAccount = 'createdAccount'
}

export type ViewerQueryVariables = Exact<{
  showId: Scalars['Int'];
}>;


export type ViewerQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', permissionsForShow: Array<PermissionLabel>, authorizedShows: Array<{ __typename?: 'Show', active: boolean, stationId: number, title?: string | null, created: any, showId: number, webStationId: string }> } };


export const ViewerDocument = gql`
    query Viewer($showId: Int!) {
  viewer {
    permissionsForShow(showId: $showId)
    authorizedShows {
      active
      stationId
      title
      created
      showId
      webStationId
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Viewer(variables: ViewerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ViewerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ViewerQuery>(ViewerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Viewer', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;